module.exports = __webpack_public_path__ + "img/medal1.131699b9.png";